import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PERSONAL_ACCESS_TOKENS_QUERY_KEY } from './usePersonalAccessTokens'
import type {CreatePatRequest, CreatePatResponse} from '@/lib/api/features/personal-access-tokens';
import {
  
  
  createPersonalAccessToken
} from '@/lib/api/features/personal-access-tokens'

export function useCreatePersonalAccessToken() {
  const queryClient = useQueryClient()
  return useMutation<CreatePatResponse, Error, CreatePatRequest>({
    mutationFn: createPersonalAccessToken,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PERSONAL_ACCESS_TOKENS_QUERY_KEY })
    },
  })
}
